import { render, staticRenderFns } from "./Recruiter.vue?vue&type=template&id=5b7116f9&"
import script from "./Recruiter.vue?vue&type=script&lang=js&"
export * from "./Recruiter.vue?vue&type=script&lang=js&"
import style0 from "./Recruiter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports